/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  permanent address response
 */

import { Bizo, SupplementalContent, autoclass } from '@zcode/bizos'
import type { Address as AddressType, RawAddress } from '@zcode/state-type'
import { MNeighborhood } from './neighborhood'

const DEFINITION = {
  addresses: 'addresses',
  cityState: 'city_state',
  createdOn: 'created_on',
  formattedAddress: 'formatted_address',
  house: 'house',
  neighborhoodId: 'neighborhood_id',
  neighborhoodName: 'neighborhood_name',
  neighborhood: { name: 'neighborhood', type: MNeighborhood },
  id: 'permanent_address_id',
  indexationReason: 'indexation_reason',
  lat: 'lat',
  lng: 'lng',
  modifiedOn: 'modified_on',
  paUrl: 'pa_url',
  pbUrl: 'pb_url',
  redirect: 'redirect',
  shouldIndex: 'should_index',
  status: 'pa_status',
  supplementalContent: { name: 'supplemental_content', type: SupplementalContent },
  units: 'units',
  url: 'pa_url',
} as const

export const Address = autoclass<AddressType, RawAddress>(
  'Address',
  class Address extends Bizo<AddressType, RawAddress> {},
  DEFINITION,
  null
)
